import { useMemo } from 'react';
import { SPSyncRow } from '../../../api/v2/SPSyncApi';

export const useFilteredRows = (rows: SPSyncRow[] | undefined, showOnlyDiffs: boolean): SPSyncRow[] => {
    return useMemo(() => {
        if (!rows) return [];
        if (!showOnlyDiffs) return rows;

        const problemStatuses = new Set(['Mismatch', 'DBOnly', 'SPOnly']);
        const keepIds = new Set<number>();
        const rowById = new Map(rows.map(r => [r.id, r]));

        for (const row of rows) {
            if (problemStatuses.has(row.status)) {
                let current: SPSyncRow | undefined = row;
                while (current && !keepIds.has(current.id)) {
                    keepIds.add(current.id);
                    current = current.parentId != null ? rowById.get(current.parentId) : undefined;
                }
            }
        }

        return rows.filter(r => keepIds.has(r.id));
    }, [rows, showOnlyDiffs]);
};
